import { buildImgproxyUrl } from '@/lib/imgproxy/imgproxy-url'

// Google recommends the main image in 16:9, 4:3 and 1:1, each at least 50K pixels.
// `fill-down` crops to the ratio but never upscales a smaller source.
const MAIN_IMAGE_CROPS = [
  { width: 1920, height: 1080 },
  { width: 1600, height: 1200 },
  { width: 1200, height: 1200 },
]

/** The main image as 16:9, 4:3 and 1:1 crops, followed by the remaining images. */
export function getStructuredDataImages(urls: readonly (string | null | undefined)[]): string[] {
  const [main, ...rest] = urls.filter((url): url is string => !!url)
  if (!main) return []

  const crops = MAIN_IMAGE_CROPS.map(({ width, height }) =>
    buildImgproxyUrl(main, {
      format: 'jpg',
      gravity: { type: 'sm' },
      quality: 80,
      resize: { height, resizing_type: 'fill-down', width },
    })
  ).filter((url): url is string => !!url)

  return crops.length ? [...crops, ...rest] : [main, ...rest]
}
